<template>
  <div>
    <PageTable
      :tableData="tableData"
      :loading="loading"
      @checkboxChange="(e) => $emit('checkboxChange', e)"
    >
      <page-header ref="header" slot="header" @query="loadData" />
    </PageTable>
  </div>
</template>
<script>
import PageTable from './table'
import PageHeader from './header'
export default {
  components: { PageHeader, PageTable },
  props: {
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  methods: {
    loadData(form) {
      this.loading = true
      this.$api
        .shipmentContainerChooseListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
